export default "__VITE_ASSET__DoZtDxwa__"